import React, {ReactNode} from 'react'
import {Link} from 'react-router-dom'
import styled from 'styled-components'
import {css} from '../lib/styled-components'

export const ButtonGroup = styled.div`
  display: flex;
  padding-top: 30px;

  justify-content: flex-start;

  > * {
    margin: 0 10px;
  }
`

const buttonStyles = css`
  display: flex;
  flex-shrink: 0;
  justify-content: left;
  border: none;
  background-color: ${p => p.theme.colors.backgroundLight};
  text-decoration: none;
  color: ${p => p.theme.colors.primary};
  border-radius: 8px;
  min-width: 100px;
  padding: 2px 8px;
  font-weight: bold;
  align-items: center;
  font-size: 1em;
  justify-content: space-around;
  svg:first-child,
  img:first-child {
    margin-right: 10px;
  }
  img {
    height: 100%;
  }
  &:hover {
    opacity: 0.8;
  }
  &:disabled {
    opacity: 0.4;
    &:hover {
      opacity: 0.4;
    }
  }
`
const StyledButton = styled.button`
  ${buttonStyles}
`

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: ReactNode
}

export const Button: React.FC<ButtonProps> = ({children, icon, ...props}) => {
  return (
    <StyledButton {...props}>
      {icon}
      <span>{children}</span>
    </StyledButton>
  )
}

export const LinkButton = styled(
  // @tx-ignore className prop is magically provided by styled-components
  ({
    to,
    children,
    className,
    style,
    icon,
    ref
  }: {
    to: string
    children: ReactNode
    className?: string
    style?: React.CSSProperties
    icon?: ReactNode
    ref?: React.Ref<HTMLAnchorElement>
  }) => {
    return to.match(/^https?:\/\//) ? (
      <a href={to} className={className} style={style} ref={ref}>
        {icon}
        <span>{children}</span>
      </a>
    ) : (
      <Link ref={ref} to={to} className={className} style={style}>
        {icon}
        <span>{children}</span>
      </Link>
    )
  }
)`
  ${buttonStyles}
`
